import { createFileRoute } from '@tanstack/react-router';
import SectionTitle from 'src/components/ui/SectionTitle';
import FAQAccordion from 'src/components/FAQAccordion';

const SupportPage = () => {
  return (
    <>
      <SectionTitle title="Frequently Asked Questions" className="px-6 py-4" />
      <div className="bg-surface-alt rounded-3xl shadow-3 px-2">
        <FAQAccordion />
      </div>
    </>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_layout-advanced/support'
)({
  component: SupportPage,
});
